import React from 'react';
import styled from 'styled-components';

import Box from 'components/Box';

export const ImageContainer = styled(
  ({ handle, format, fixedWidth, fullWidth, overlapping, ...props }) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box {...props} />
  )
)`
  width: 100%;
  height: 100%;
  background-position: center;
  ${(props) => `
    background-size: ${props.fixedWidth ? 'contain' : 'cover'};
    ${
      !props.fixedWidth
        ? `
      * {
        width: 100%;
        height: 100%;
      }
      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
      }
      img {
        width: 100%;
        height: auto;
        display: none;
      }
      @supports (object-fit: cover) {
        img {
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }
      }
    `
        : `
      img {
        width: 100%;
      }
      @supports (object-fit: contain) {
        img {
          height: 100%;
          object-fit: contain;
          object-position: center;
          display: block;
        }
      }
        `
    }
  `}
`;
